import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { goldBtn } from '../ui';
import { api, eur, errMsg } from '../api';

export default function FormalitaPicker({ req, cons, price, onDone }) {
  const [sel, setSel] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const taken = new Set(req.notes.filter((n) => n.cons === cons.code && n.status !== 'error').map((n) => n.fid));
  const toggle = (id) => { setConfirm(false); setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]); };
  const order = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/property/mortgage/${req.id}/notes`, { items: sel.map((fid) => ({ cons: cons.code, fid })) });
      if (r.data.warning) toast.warning(r.data.warning); else toast.success('Note richieste: ti avvisiamo appena pronte');
      setSel([]); setConfirm(false); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 border-t border-[#1F242C] pt-4" data-testid={`mortgage-formalita-${cons.code}`}>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#5A5F67] mb-2">Elenco sintetico · {cons.name}</p>
      {!cons.formalita.length && <p className="text-xs text-[#8A8F97]">Nessuna formalità.</p>}
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left text-[#5A5F67]"><th className="py-1 pr-2" /><th className="pr-3">Data</th><th className="pr-3">Tipo</th><th className="pr-3">Reg. gen./part.</th><th>Descrizione</th></tr></thead>
          <tbody>
            {cons.formalita.map((f) => (
              <tr key={f.id} className="border-t border-[#12161B] text-[#C9CCD1]" data-testid={`mortgage-formalita-row-${f.id}`}>
                <td className="py-2 pr-2">{taken.has(f.id) ? <span className="text-[10px] text-[#D4AF37]">richiesta</span> : <input type="checkbox" className="accent-[#D4AF37]" checked={sel.includes(f.id)} onChange={() => toggle(f.id)} data-testid={`mortgage-formalita-check-${f.id}`} />}</td>
                <td className="pr-3 font-mono whitespace-nowrap">{f.data}</td>
                <td className="pr-3 whitespace-nowrap">{f.tipo}</td>
                <td className="pr-3 font-mono whitespace-nowrap">{f.reg_gen || '-'} / {f.reg_part || '-'}</td>
                <td className="min-w-[180px]">{f.descr}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {sel.length > 0 && (
        <button onClick={() => (confirm ? order() : setConfirm(true))} disabled={busy} className={`${goldBtn} h-10 px-4 mt-3 inline-flex items-center gap-2 text-sm`} data-testid={`mortgage-notes-order-${cons.code}`}>
          {busy && <Loader2 size={14} className="animate-spin" />}
          {confirm ? `Conferma addebito ${eur((price || 0) * sel.length)}` : `Apri ${sel.length} ${sel.length === 1 ? 'nota' : 'note'} · ${eur(price || 0)} cad.`}
        </button>
      )}
    </div>
  );
}
